// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery'
import store from './store'//引入store
import "babel-polyfill"
//分享

// 数据请求
import { http } from './libs/http'
Vue.prototype.$http = http
//外部css
import "../static/css/share.css"
import "../static/css/mui.min.css"
//适配rem
import 'lib-flexible/flexible.js'
Vue.config.productionTip = false

import host from './libs/config'
Vue.prototype.$host = host.Host
// console.log(host);

import vueSwiper from 'vue-awesome-swiper'
/* 样式的话，我这里有用到分页器，就在全局中引入了样式 */
import 'swiper/dist/css/swiper.css'
Vue.use(vueSwiper);


router.beforeEach((to, from, next) => {
   /* 路由发生变化修改页面meta */ 
  if(to.meta.content){ 
    let head = document.getElementsByTagName('head'); 
    let meta = document.createElement('meta'); 
    meta.itemprop="description";
    meta.content = to.meta.content;
    head[0].appendChild(meta)
  }
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  $,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js